import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { getVehicleAction } from "../../actions/getVehicle";
import NodataFound from "../../component/NodataFound";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";
const Module = ({ modulelist, onmoduleSearch, startIndex, handleModuleSearchInput, handleVehiclelistInput, handleEditButton, searchInputValue, Vehiclename }) => {
  const [getVehicleList, setGetVehicleList] = useState([]);
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    VehicleListData();
  }, []);
  async function VehicleListData() {
    let response = await dispatch(getVehicleAction());
    if (response == 200 || response != null) {
      setGetVehicleList(response.data.data.results);
    }
  }


  return (
    <div>
      <div>
        <div className="productTrainingdropdown_textfield">
          <div className="productTrainingdropdown_module">
            <div class="input-wrapper">
              <label for="first">{t('training_module.selectVehicle')}</label>
              <select
                name="Vehiclename"
                value={Vehiclename}
                onChange={handleVehiclelistInput}
              >
                <option value="">{t('training_module.selectVehicle')}</option>
                {getVehicleList.map((data) => (
                  <option value={data.id} key={data.id}>{data.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="productTrainingdropdown_div">
            <div class="input-wrapper">
              <label for="search">{t('training_module.search')}</label>
              <input className="input_search" type="text" placeholder={t('training_module.enterSearchText')} value={searchInputValue} onChange={handleModuleSearchInput} />
            </div>
          </div>
          <button disabled={!searchInputValue && !Vehiclename} className="btn_search_module" onClick={() => onmoduleSearch(Vehiclename, searchInputValue)}> {t('training_module.search')}</button>
        </div>
      </div>
      <div>
        <div className="tabledata">
          {modulelist?.length > 0 ?
            <table className="table">
              <tr>
                <th className="tablesth"> {t('training_module.sNo')}</th>
                <th className="tablesth">{t('training_module.thumbnail')}</th>
                <th className="tablesth">{t('training_module.moduleName')}</th>
                <th className="tablesth">{t('training_module.description')}</th>
                <th className="tablesth">{t('training_module.content')} </th>
                {hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_MODULE_DETAILS)  && (
                <th className="tablesth"></th>
                )}
              </tr>
              {modulelist?.map((data, ind) => (
                <tr>
                  <td className="tabletd">{ind + startIndex}</td>
                  <td className="tabletd">
                    <img height="108px" width="108px"
                      src={
                        data.attachment ? data.attachment : Image_Url.VIDEO_THUMBNAIL
                      }
                      className="module_thumbnails"
                    />
                  </td>
                  <td className="tabletd">{data.name}</td>
                  <td className="tabletd"><Tooltip arrow title={String(data?.description).length>100?String(data.description):""}><div style={{padding:0,marginBottom:"-20px"}}>{String(data.description).substring(0,100) + (String(data?.description).length>100?"...":"")}</div></Tooltip> </td>
                  <td className="tabletd">
                    {t('training_module.video')} {data?.content.video}
                    <p className="pdf-text">{t('training_module.pdf')} {data?.content.pdf}</p>
                  </td>
                  {hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_MODULE_DETAILS) && (
                    <td
                    className="tabletd_view"
                    onClick={() => {
                      handleEditButton(data.id);
                    }}
                  >
                    {t('training_module.edit')}
                  </td>
                  )}
                </tr>
              ))}
            </table>
            :
            <NodataFound/>
          }
        </div>
      </div>

    </div>
  );
};

export default Module;
